import { render } from "./FinancialTransferModal.vue?vue&type=template&id=bc383894&scoped=true"
import script from "./FinancialTransferModal.vue?vue&type=script&lang=js"
export * from "./FinancialTransferModal.vue?vue&type=script&lang=js"

import "./FinancialTransferModal.vue?vue&type=style&index=0&id=bc383894&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc383894"]])

export default __exports__